module.exports = __webpack_public_path__ + "static/media/CEDIA-Cosecha-platanos.30e12c91.JPG";